import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import formDefault from "../../docs/formDefault.json";

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }
}
